<!-- eslint-disable -->
<template lang="pug">
    div
        rating-preview(
            v-for="(rating, index) in modifiedItems"
            :rating="rating"
            :prevRating="items[index - 1]"
            :key="rating.id"
            :index="index"
            :perPage="perPage"
        )
</template>

<script>
    /*eslint-disable*/
    import RatingPreview from './Preview.vue';
    export default {
        props: ['items', 'index', 'perPage'],
        components: {
            RatingPreview
        },
        computed: {
            modifiedItems () {
                let page = this.$route.query.page;
                return this.items.map((rating, index, arr) => {
                    let prevRating = arr[index - 1];
                    rating.computedPosition = prevRating && prevRating.points === rating.points ?
                            prevRating.computedPosition : index + 1 + (page ? page - 1 : 0) * this.perPage;
                    return rating;
                });
            }
        }
    }
</script>
